import React from "react";
import { NavLink } from "react-router-dom";
import { House, ClipboardText, BellRinging, ChartBar, User } from "@phosphor-icons/react";
import { useLang } from "@/i18n";

const items = [
  { to: "/", icon: House, key: "home", end: true },
  { to: "/add-visit", icon: ClipboardText, key: "visits" },
  { to: "/followups", icon: BellRinging, key: "followups" },
  { to: "/summary", icon: ChartBar, key: "summary" },
  { to: "/profile", icon: User, key: "profile" },
];

export function BottomNav() {
  const { t } = useLang();
  return (
    <nav className="fixed bottom-0 inset-x-0 z-30 bg-white border-t border-slate-200 max-w-md mx-auto" data-testid="bottom-nav">
      <div className="grid grid-cols-5">
        {items.map(({ to, icon: Icon, key, end }) => (
          <NavLink
            key={key}
            to={to}
            end={end}
            data-testid={`nav-${key}`}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 py-2 text-[11px] font-medium transition-colors ${
                isActive ? "text-emerald-600" : "text-slate-400"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon size={22} weight={isActive ? "fill" : "regular"} />
                {t(key)}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
